<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="  mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Service Management </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/servicejob/index"> Manage Job  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Job Creation  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2 ">
  <div  class="card-body custom_bdr_rds">


  


  

   

                    <form @submit.prevent="SaveQuotation()" >


<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Booking Number</label>
            <input  v-model="all_data.id"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Engine Number</label>
            <input  v-model="all_data.engi_no"   style="font-size: small;" class="form-control" disabled>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Model Name </label>
           
            <input v-model="all_data.modelname"   style="font-size: small;" class="form-control" disabled>
            <input v-model="all_data.model_id"  type="hidden" />
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Date</label>
            <input type="date" v-model="all_data.date"   style="font-size: small;" class="form-control" required>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer </label>
           
            <v-select class="font-size_def" label="value" v-model="all_data.user_full_name" disabled></v-select>

            <input v-model="all_data.user_full_name_id" type="hidden" />
         
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact No. </label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <input  v-model="all_data.user_contact_tel1"   style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Service technician </label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <v-select class="font-size_def" label="name" v-model="all_data.technician_id" :options="technicians" ></v-select>
           
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Service Advisor</label>
            <!-- <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select> -->
            <v-select class="font-size_def" label="name" v-model="all_data.advisor_id"  :options="advisors"></v-select>
           
    </div>
  </div>


  
</div>


<div class="row">

 


  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="all_data.remarks" class="form-control" rows="2"></textarea>
    </div>
  </div>

</div>


<!-- <div class="row">
  <div class="col-md-3">
    <button type="button"  @click="pendingQuotation()"  class="btn btn-sm  btn-outline-primary mb-1 font-size_def"> View Pending Quotation</button>

    </div>
</div> -->














<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Add Parts</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
                <th></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Selling Price</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Available Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Discount %</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Line Amount</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> GP Margin</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> % GP Margin</label>
                  </div>
                </th>
              
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
                <td> </td>
              <td style="width: 20%;">
                <v-select  v-model="detail[0].idproduct" label="label"  :options="mproducts" @input="loadPrice(0)"></v-select>
              </td>
              <td><input v-model="detail[0].price"  style="font-size: small;" class="form-control text_right" disabled>
                <input type="hidden" v-model="detail[0].ave_cost"  style="font-size: small;" class="form-control" >
                <input type="hidden" v-model="detail[0].status"  style="font-size: small;" class="form-control" >
              </td>
              <td><input  v-model="detail[0].avlqty" style="font-size: small;" class="form-control text_right" disabled></td>
              <td><input  v-model="detail[0].qty" style="font-size: small;" class="form-control text_right" @input="calculateqty(0)" ></td>
              <td>
                <input  v-model="detail[0].line_discount" style="font-size: small;" class="form-control text_right" @input="calculatediscount(0)">
              </td>
              <td><input  v-model="detail[0].line_amount"  @input="calculatelinamt(0)" style="font-size: small;" class="form-control text_right" ></td>
              <td><input  v-model="detail[0].gp_margin" @input="calculategpmarg(0)"  style="font-size: small;" class="form-control text_right" ></td>
              <td><input v-model="detail[0].gp_margin_precentage" @input="calculategppre(0)"  style="font-size: small;" class="form-control text_right " required></td>
             
             
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
              <td> <v-select v-model="detail[key].idproduct" label="label"  :options="mproducts" @input="loadPrice(key)"></v-select></td>
              <td><input  v-model="detail[key].price" style="font-size: small;" class="form-control text_right" disabled>
                <input type="hidden" v-model="detail[key].ave_cost"  style="font-size: small;" class="form-control " >
                <input type="hidden" v-model="detail[key].status"  style="font-size: small;" class="form-control " >
              </td>
              <td><input  v-model="detail[key].avlqty" style="font-size: small;" class="form-control text_right" disabled></td>
              <td><input  v-model="detail[key].qty" style="font-size: small;" class="form-control text_right" @input="calculateqty(key)" ></td>
              <td><input  v-model="detail[key].line_discount" style="font-size: small;" class="form-control text_right" @input="calculatediscount(key)" ></td>
              <td><input  v-model="detail[key].line_amount" @input="calculatelinamt(key)" style="font-size: small;" class="form-control text_right" ></td>
              <td><input  v-model="detail[key].gp_margin" @input="calculategpmarg(key)" style="font-size: small;" class="form-control text_right" ></td>
          
              <td><input v-model="detail[key].gp_margin_precentage" @input="calculategppre(key)" style="font-size: small;" class="form-control text_right" required></td>

             


              <td class="custom-icon"> 
              
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
           
            
            <tr >
                <td> </td>
              <td></td>
              <td>Sub Total</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td class="text_right" >{{ subtotal }}</td>
              <td class="text_right">{{ gpmrg_total }}</td>
              <td class="text_right">{{ gpMrgPre_total }}</td>
            
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Special Discount</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td><input v-model="quotation.special_discount"  style="font-size:small" class="form-control text_right" @input="spe_dis"></td>
              <td></td>
              <td></td>
          
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Total</td>
              <td></td>
              
              <td></td>
              <td></td>
              <td class="text_right">{{ final_total }}</td>
              <td></td>
              <td></td>
             
              <td></td>
              
            </tr>

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
   
    this.loadCustomer();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        mcustomers:[],
        mproducts:[],
        contacts:[],
      salespeoples:[

      ],
      errors: {},
     
      
      all_data:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        technicians:[],
        advisors:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],
        validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

       




     

    

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/servicejob/loaddata?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
          this.technicians = data.technicians;
          this.advisors = data.advisors;
          this.mproducts = data.mproducts;
       
         
       } catch (error) {
         console.log(error.response);
       }
     },

     

     

     async loadPrice(id) {
       
     
       try {
         const { data} = await  axios.post('/servicejob/loadprice',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'price', data.selling_price);
          this.$set(this.detail[id], 'avlqty', data.avl);
          this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          this.$set(this.detail[id], 'status', data.status);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
    
     if(parseFloat(this.detail[id].avlqty) < parseFloat(this.detail[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.detail[id], 'qty', this.detail[id].avlqty);

      
     }
  const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


     async calculatelinamt(id) {

      const discount = (100 - ((this.detail[id].line_amount*100)/(this.detail[id].price*this.detail[id].qty))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', discount);

      const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.detail[id].line_amount*100).toFixed(2);
      this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },

     async calculategpmarg(id) {
      
       const dis = (100-((parseFloat(this.detail[id].gp_margin / this.detail[id].qty) + parseFloat(this.detail[id].ave_cost))*100/this.detail[id].price)).toFixed(2);
        this.$set(this.detail[id], 'line_discount', dis);


        const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrgPre = (this.detail[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);


     },

     async calculategppre(id) {

      const dis =  (100 -(this.detail[id].ave_cost*10000/((this.detail[id].price)*(100-this.detail[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', dis);

      const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },



     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
      if(this.sales == null){
        this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      }
      if(this.quotation.id_brand == null){
        this.$set(this.errors, 'idbrandError', "Brand field is required");
      }
     },

    async SaveQuotation() {
     
   

   
        try {
         const { data} = await  axios.post('/servicejob/create',{userid:this.userid,all_data:this.all_data,detail:this.detail,quotation:this.quotation},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/servicejob/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
    
       
      
 
      
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    